<template>
    <div id='footer'>
        <div class="footer_main pubw">
            <ul class="navUl" ref="navUl">
                <li>
                    <h3>
                        <img class='logo' src="@/assets/img/logowhite.png" alt="logo" @click="$router.push('/')"></img>
                    </h3>
                    <p class="introduction">Goods 2 Go 是一個在線多合一
                        的物流解決方案平台，可幫助您
                        比較和預訂全球和國內門到門快
                        遞，並立即為您提供運費。
                    </p>
                    <div class="langage" :class="showLanguageSelect?'active':''">
                        <div class="h" @click="hanglerlanguage">
                            <span class="iconfont icon-diqiu"></span>
                            <h4 class="choiceLangage">{{currentLangage}}</h4>
                            <span class="el-icon-caret-bottom"></span>
                        </div>
                        <ul class="select">
                            <li  v-for="item in langageData"  :key="item.value" @click="changeLange(item)">{{item.label}}</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <div class="h"  @click="showSublist(1)">
                        <h3>關於 Goods 2 Go</h3>
                        <span class="el-icon-arrow-down"></span>
                    </div>
                    <ul>
                        <p>關於我們</p>
                        <p>商業寄件</p>
                        <p >私人寄件</p>
                        <p>加入我們</p>
                        <p @click="policy">AML & KYC政策</p>
                        <p @click="privacyClause">私隱條款</p>
                    </ul>
                </li>
                <li>
                    <div class="h" @click="showSublist(2)">
                        <h3>寄件教學</h3>
                        <span class="el-icon-arrow-down"></span>
                    </div>
                    <ul>
                        <p>
                            <router-link to="/mailTeaching/1">電子產品</router-link>
                        </p>
                        <p>
                            <router-link to="/mailTeaching/3">食品</router-link>
                        </p>
                        <p>
                            <router-link to="/mailTeaching/2">其他物品</router-link>
                        </p>
                        <p>
                            <router-link to="/mailTeaching/3">禁運及限制物品</router-link>
                        </p>
                        <p>
                            <router-link to="/mailTeaching/4">FAQ</router-link>
                        </p>
                    </ul>
                </li>
                <li>
                    <div class="h" @click="showSublist(3)">
                        <h3>聯繫我們</h3>
                        <span class="el-icon-arrow-down"></span>
                    </div>
                    <ul>
                        <p>如有任何疑問, 我們很樂意為你服務。</p>
                        <p>
                            <img src="@/assets/img/email.png" alt="Responsive image"></img>
                            <i>hello@everrise.com</i>
                        </p>
                        <p>
                            <img src="@/assets/img/facebook.png" alt="Responsive image"></img>
                            <i>Facebook</i>
                        </p>
                        <p>
                            <img src="@/assets/img/camera.png" alt="Responsive image"></img>
                            <i>Instagram</i>
                        </p>
                    </ul>
                </li>
            </ul>
            <div class="copyright">©2017 - 2021 Everrise Group Limited. All rights reserved.</div>
        </div>
    </div>
  </template>
  
  <script>
    // 引入组件
    export default {
      mame:'Footer',
      components:{
      },
      data() {
        return {
            // 控制语言下拉框是否展示
            showLanguageSelect:'',
            // 当前语言
            currentLangage:'繁體中文',
            // 语言列表
            langageData:[
                {
                    value: 'hk',
                    label: '繁體中文'
                }, {
                    value: 'zh',
                    label: '简体中文'
                }, {
                    value: 'en',
                    label: 'English'
                }
            ]
        }
      },
      mounted() {
          this.langageData.forEach(item => {
              if(item.value == window.localStorage.getItem("language")){
                  this.currentLangage = item.label
              }
          })
      },
      methods: {
        //   选择语言
        changeLange(value){
            this.currentLangage = value.label
            window.localStorage.setItem("language",value.value)
            this.$i18n.locale = value.value
        },
        // 显示选项
        showSublist(index){
            let navUl = this.$refs.navUl
            let hasactive = navUl.children[index].getAttribute("class") == 'subListActive'
            if(hasactive) return navUl.children[index].classList.remove("subListActive")
            navUl.children[index].classList.add("subListActive")
        },
        // 监听用户点击选择语言
        hanglerlanguage(){
            this.showLanguageSelect = !this.showLanguageSelect
        },
        // AML & KYC政策
        policy(){
            window.open("https://www.hkma.gov.hk/chi/key-functions/banking/anti-money-laundering-and-counter-financing-of-terrorism/");
        },
        // 隐私条款
        privacyClause(){
            window.open("http://goods2go.com.hk/goods2go-user/img/pdf/Privacy%20Policy(Everrise-Goods2go).pdf");
        },
      }
    }
  </script>
  
  <style lang="less" scoped>
      .navUl li .h span{
          display: none;
      }
      #footer{
          display: flex;
          justify-content: center;
          background-color: #575D7E;
            height: 531.82px;
      }
      .footer_main{
        margin-top: 50px;
    }
    .navUl{
        display: flex;
        justify-content: space-between;
        .langage{
            color: #fff;
            margin-top:25px;
            padding: 10px;
            margin-left:-10px;
            .choiceLangage{
                font-size: 17px;
                margin: 5px 0;
                margin-left: 20px;
                margin-right: 40px;
            }
            .select{
                display: none;
                line-height: 30px;
                font-size: 15px;
                li{
                    &:hover{
                     color:#a6a6a7;
                      cursor: pointer;
                    }
                }
            }
            .h{
                display: flex;
                align-items:center;
                .el-icon-caret-bottom{
                    animation: arrowDown 0.6s forwards;
                }
                &:hover{
                     color:#a6a6a7;
                    cursor: pointer;
                        .el-icon-caret-bottom{
                        animation: arrowUp 0.6s forwards;
                    }
                }
                span{
                    font-size: 20px;
                    display: block;
                }
            }
            .select{
                width: 35%;
            }
        }
        .langage.active{
            background-color: #000;
            .select{
                display: block;
            }
        }
        li{
            width: 198px;
            padding:0 10px;
            h3{
                color: #fff;
                font-weight:550;
                height: 45px;
                line-height:40px;
                font-family: Source Han Sans HK;
                white-space: nowrap;
            }
            p{
                color: #91a3c1;
                font-size: 13px;
                line-height: 20px;
                display: flex;
                margin-top: 45px;
                img{
                    display: block;
                    margin-right:10px;
                }
                a{
                    color: #91a3c1;
                    font-size: 13px;
                }
            }
            p:hover{
                color:#a6a6a7;
                cursor: default;
            }
            .logo{
                width: 192px;
                height: 40px;
                &:hover{
                    opacity: .8;
                    cursor: pointer;
                }
             }
        }
    }
    .el-input__inner{
        background-color:#575D7E !important;
    }
    .copyright{
        color: #FFFFFF;
        font-size: 0.8125rem;
        font-size: 13px;
        font-family: 'PingFangHK';
        margin: 0 auto;
        text-align: center;
        bottom: 20px;
        margin-top: 25px;
    }
    /* 最大宽度768px 手机 */
    @media screen and (max-width: 768px){
        #footer{
            height: auto;
            padding-bottom: 5px;
        }
        .footer_main{
            margin-top: 10px;
        }
        .navUl{
            flex-wrap: wrap;
            li{
                width: 95%;
                text-align: center;
                margin: 0 auto;
                .h{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    span{
                        display: block;
                        color: #fff;
                        font-size: 20px;
                        animation: arrowDown .6s forwards;
                    }
                }
                .langage{
                    display: flex;
                    justify-content: space-between;
                }
                p{
                    margin-top: 5px;
                }
                h3{
                    margin-top: 5px;
                }
                ul{
                    height: 0px;
                    overflow: hidden;
                    transition: 0.6s;
                    p{
                        margin-top: 10px;
                    }
                
                }
                .introduction{
                    display: none;
                }
            }
            .subListActive .h span{
                animation: arrowUp .6s forwards;
            }
            .subListActive ul{
                height: 200px;
            }
        }
    }
  </style>